export default "__VITE_ASSET__BENzdIHF__"